import { render, staticRenderFns } from "./DocToolbar.vue?vue&type=template&id=3ab1564c&scoped=true&"
import script from "./DocToolbar.vue?vue&type=script&lang=js&"
export * from "./DocToolbar.vue?vue&type=script&lang=js&"
import style0 from "./DocToolbar.vue?vue&type=style&index=0&id=3ab1564c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab1564c",
  null
  
)

export default component.exports